import { Controller } from 'stimulus'

export default class extends Controller {

  openModal(e) {
  	e.preventDefault()
    window.dispatchEvent(new CustomEvent("openLeadooModal"))
  }
}